<template>
  <span>
    <img draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 3.png" alt="">

    <span v-show="$store.getters['app/overlays'].show_game_overlay">
        <span id="end_text_title">Hoelang moet je sporten?</span>
        <span class="end_text_description" id="end_text_description_1">1 glas frisdrank (55kcal) 13 minuten wandelen of 7 minuten fietsen</span>
        <span class="end_text_description" id="end_text_description_2">1 ijsje(300kcal) 70 minuten wandelen of 41 minuten fietsen</span>
        <span class="end_text_description" id="end_text_description_3">1 glas vruchtensap (50kcal) 12 minuten wandelen of 7 minuten fietsen</span>
        <span class="end_text_description" id="end_text_description_4">1 muffin (265kcal) 48 minuten wandelen of 25 minuten hardlopen</span>

        <img draggable="false" id="figure_1" src="./../assets/images/figures/Asset 2.png" alt="">
        <img draggable="false" id="figure_2" src="./../assets/images/figures/Asset 3.png" alt="">
        <img draggable="false" id="figure_3" src="./../assets/images/figures/Asset 4.png" alt="">
        <img draggable="false" id="figure_4" src="./../assets/images/figures/Asset 5.png" alt="">
        <img draggable="false" id="figure_5" src="./../assets/images/figures/Asset 6.png" alt="">
    </span>
  </span>
</template>

<script>

export default {
  name: "End",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
  },

  computed: {}
};
</script>

<style>
  #figure_1 {
    position: absolute;
    left: 16%;
    margin-top: 38%;
    width: 10%;
  }
  #figure_2 {
    position: absolute;
    left: 32%;
    margin-top: 38%;
    width: 10%;
  }
  #figure_3 {
    position: absolute;
    left: 48%;
    margin-top: 37.7%;
    width: 7%;
  }
  #figure_4 {
    position: absolute;
    left: 62%;
    margin-top: 37.7%;
    width: 6.5%;
  }
  #figure_5 {
    position: absolute;
    left: 77%;
    margin-top: 37.7%;
    width: 5.8%;
  }

  #end_text_title {
    width: 70%;
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    left: 15%;
    color: #fff;
    font-size: 4vw;
    text-align: center;
  }
  .end_text_description {
    font-family: 'LuckiestGuy';
    position: absolute;
    left: 5%;
    color: #fff;
    font-size: 2.2vw;
    width: 90%;
    text-align: center;
  }
  #end_text_description_1 {
    margin-top: 12%;
  }
  #end_text_description_2 {
    margin-top: 16%;
  }
  #end_text_description_3 {
    margin-top: 20%;
  }
  #end_text_description_4 {
    margin-top: 24%;
  }
</style>


